import React from 'react';
import { MARKS, BLOCKS, INLINES } from '@contentful/rich-text-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

function Strong({ children }) {
  return <strong>{children}</strong>;
}

function PullQuote({ children, position }) {
  return (
    <aside className={position}>
      <blockquote dangerouslySetInnerHTML={{ __html: children }} />
    </aside>
  );
}

const getEmbeddedEntryComponent = (node) => {
  if (node?.data?.target?.__typename === 'ContentfulPullQuote') {
    return (
      <PullQuote position={node?.data?.target?.position}>
        {node?.data?.target?.quote?.childMarkdownRemark?.html}
      </PullQuote>
    );
  } if (node?.data?.target?.__typename === 'ContentfulAsset') {
    const { gatsbyImageData, description } = node?.data?.target;
    return <GatsbyImage image={getImage(gatsbyImageData)} alt={description} />;
  }

  return <pre>{JSON.stringify(node, null, 2)}</pre>;
};

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <Strong>{text}</Strong>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const { content } = node;

      if (
        content.find((item) => item.nodeType === INLINES.EMBEDDED_ENTRY)
      ) {
        return children;
      }

      return <p>{children}</p>;
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node) => getEmbeddedEntryComponent(node),
    [INLINES.EMBEDDED_ENTRY]: (node) => getEmbeddedEntryComponent(node),
    [BLOCKS.EMBEDDED_ASSET]: (node) => getEmbeddedEntryComponent(node),
  },
};

export default options;
